<template>
    <div class="animated fadeIn">
        <b-card >
            <template v-slot:header>
                <h5>Laporan PP/ PL</h5>
            </template>
            <div class="laporan-head-wrapper">
                <b-button variant="pgiBtn" class="mr-2" @click="openLaporanPeriode()">
                    Laporan Periode
                </b-button>
                <b-button variant="pgiBtn" class="mr-2" @click="openLaporanTahunan()">
                    Laporan Tahunan
                </b-button>
            </div>
        </b-card>
        <div v-if="showWebPeriode">
            <div class="text-center" v-if="isLoading">
                <b-spinner class="align-middle mb-4"></b-spinner>
                <p class="mb-0">Sedang memproses, mohon menunggu...</p>
            </div>
            <div v-else>
                <div class="mb-4 d-flex align-items-center justify-content-between laporan-periode-wrapper">
                    <div class="laporan-periode">
                        <h4>Laporan {{ input.tipePembayaranPeriode == 1 ? "Perpanjangan" : "Pelunasan" }}</h4>
                        <h6>
                            Periode : 
                            <span>{{$helper.changeDateFormat(periodeStart)}}</span>
                            <span v-if="periodeEnd != ''"> - {{$helper.changeDateFormat(periodeEnd)}}</span>
                        </h6>
                    </div>
                </div>
                <div class="mb-4">
                    <b-form-group class="form-inline" label-for="tipePembayaran" label="Tipe Pembayaran">
                        <b-form-select class="ml-2" v-model="input.tipePembayaranPeriode" id="tipePembayaran" name="tipePembayaran" :options="tipePembayaranOption" value-field="id" text-field="name">
                        </b-form-select>
                    </b-form-group>
                </div>
                <b-row>
                    <b-col lg="4" sm="6" cols="12">
                        <div class="custom-card-dashboard balance-card">
                            <div class="d-flex align-items-center">
                                <div class="card-icon">
                                    <i class="mb-2 fa fa-laptop"></i>
                                </div>
                                <div class="card-data ml-4">
                                    <p class="mb-0 text-muted">Gadai Elektronik</p>
                                    <strong class="mb-0">
                                        Rp. {{$helper.addThousandSeparator(showDataPembayaranAll.nominalElek)}}
                                    </strong>
                                    <p class="mb-0">{{$helper.addThousandSeparator(showDataPembayaranAll.jumlahElek)}} Unit</p>
                                </div>
                            </div>
                        </div>
                    </b-col>
                    <b-col lg="4" sm="6" cols="12">
                        <div class="custom-card-dashboard balance-card">
                            <div class="d-flex align-items-center">
                                <div class="card-icon">
                                    <i class="mb-2 fa fa-book"></i>
                                </div>
                                <div class="card-data ml-4">
                                    <p class="mb-0 text-muted">Gadai BPKB</p>
                                    <strong class="mb-0">
                                        Rp. {{$helper.addThousandSeparator(showDataPembayaranAll.nominalBpkb)}}
                                    </strong>
                                    <p class="mb-0">{{$helper.addThousandSeparator(showDataPembayaranAll.jumlahBpkb)}} Unit</p>
                                </div>
                            </div>
                        </div>
                    </b-col>
                    <b-col lg="4" sm="6" cols="12">
                        <div class="custom-card-dashboard balance-card">
                            <div class="d-flex align-items-center">
                                <div class="card-icon">
                                    <i class="mb-2 fa fa-car"></i>
                                </div>
                                <div class="card-data ml-4">
                                    <p class="mb-0 text-muted">Gadai Kendaraan</p>
                                    <strong class="mb-0">
                                        Rp. {{$helper.addThousandSeparator(showDataPembayaranAll.nominalKend)}}
                                    </strong>
                                    <p class="mb-0">{{$helper.addThousandSeparator(showDataPembayaranAll.jumlahKend)}}</p>
                                </div>
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <b-card >
                    <template v-slot:header>
                        <h5>Laporan {{ input.tipePembayaranPeriode == 1 ? "Perpanjangan" : "Pelunasan" }} Cabang</h5>
                    </template>
                    <div class="search-wrapper d-flex align-items-center justify-content-between">
                        <b-form-group
                            label="Filter"
                            label-for="filterInput"
                            class="form-inline form-group-wrapper mb-3"
                        >   
                            <div class="d-flex search-input-wrapper">
                                <multiselect
                                    class="ml-2 mr-2"
                                    name="filterCabang"
                                    v-model="input.filterCabang" 
                                    :options="cabangOption" 
                                    :internal-search="true"
                                    :allow-empty="true"
                                    deselect-label=""
                                    select-label=""
                                    label="name"
                                    track-by="name"
                                    placeholder="-- Pilih filter cabang --"
                                />
                                <b-button class="mr-2" variant="pgiBtn" name="searchTableBtn" :disabled="isBusy" @click="onFilter()"> 
                                    <i class="fa fa-search"></i>
                                </b-button>
                                <b-button variant="pgiBtn" name="resetTableBtn" :disabled="isBusy" @click="onReset()">Reset</b-button>
                            </div>
                        </b-form-group>
                    </div>
                    <b-table bordered hover show-empty
                        :busy="isBusy"
                        :items="showDataPembayaran" 
                        :fields="fields" 
                        :currentPage="currentPage" 
                        :perPage="perPage"
                        responsive class="mb-3">
                        <template v-slot:table-busy>
                            <div class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong>  Loading data...</strong>
                            </div>
                        </template>
                        <template v-slot:empty>
                            Tidak ada data pembayaran.
                        </template>
                        <template v-slot:thead-top>
                            <b-tr>
                                <b-th># </b-th>
                                <b-th colspan="2">Elektronik</b-th>
                                <b-th colspan="2">BPKB</b-th>
                                <b-th colspan="2">Kendaraan</b-th>
                            </b-tr>
                        </template>
                        <template v-slot:cell(jumlahElek)="row">
                            <div class="text-right no-wrap">
                                {{ $helper.addThousandSeparator(row.item.jumlahElek) }}                 
                            </div>
                        </template>
                        <template v-slot:cell(jumlahKend)="row">
                            <div class="text-right no-wrap">
                                {{ $helper.addThousandSeparator(row.item.jumlahKend) }}                 
                            </div>
                        </template>
                        <template v-slot:cell(jumlahBpkb)="row">
                            <div class="text-right no-wrap">
                                {{ $helper.addThousandSeparator(row.item.jumlahBpkb) }}                 
                            </div>
                        </template>
                        <template v-slot:cell(nominalElek)="row">
                            <div class="text-right no-wrap" v-if="row.item.nominalElek == null">{{$helper.addThousandSeparator(row.item.nominalElek)}} </div>
                            <div class="text-right no-wrap" v-else-if="row.item.nominalElek < 0">- Rp{{$helper.addThousandSeparator(row.item.nominalElek).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.nominalElek)}} </div>
                        </template>
                        <template v-slot:cell(nominalKend)="row">
                            <div class="text-right no-wrap" v-if="row.item.nominalKend == null">{{$helper.addThousandSeparator(row.item.nominalKend)}} </div>
                            <div class="text-right no-wrap" v-else-if="row.item.nominalKend < 0">- Rp{{$helper.addThousandSeparator(row.item.nominalKend).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.nominalKend)}} </div>
                        </template>
                        <template v-slot:cell(nominalBpkb)="row">
                            <div class="text-right no-wrap" v-if="row.item.nominalBpkb == null">{{$helper.addThousandSeparator(row.item.nominalBpkb)}} </div>
                            <div class="text-right no-wrap" v-else-if="row.item.nominalBpkb < 0">- Rp{{$helper.addThousandSeparator(row.item.nominalBpkb).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.nominalBpkb)}} </div>
                        </template>
                    </b-table>

                    <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                        <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
                            <b-form-select v-model="input.show" id="showItems" @change="onLimitChange" :options="options">
                                <template v-slot:first>
                                    <b-form-select-option :value="null" disabled />
                                </template>
                            </b-form-select>
                            <span class="ml-2">{{ totalViewText }}</span>
                        </b-input-group>
                        <b-pagination class="mb-0"
                            v-model="currentPage"
                            :total-rows="rows"
                            :per-page="perPage"
                            aria-controls="my-table"
                            @input="onPageChange"
                        ></b-pagination>
                    </div>
                </b-card>
            </div>
        </div>
        <div v-if="showWebTahunan">
            <div class="text-center" v-if="isLoading">
                <b-spinner class="align-middle mb-4"></b-spinner>
                <p class="mb-0">Sedang memproses, mohon menunggu...</p>
            </div>
            <div v-else>
                <div class="mb-4 d-flex align-items-center justify-content-between laporan-periode-wrapper">
                    <div class="laporan-periode">
                        <h4>Laporan {{ input.tipePembayaranPeriode == 1 ? "Perpanjangan" : "Pelunasan" }}</h4>
                        <h6>
                            Periode : Tahun {{ periodeTahun }}
                        </h6>
                    </div>
                </div>
                <div class="mb-4">
                    <b-form-group class="form-inline" label-for="tipePembayaran" label="Tipe Pembayaran">
                        <b-form-select class="ml-2" v-model="input.tipePembayaranTahunan" name="tipePembayaranTahunan" :options="tipePembayaranOption" value-field="id" text-field="name">
                        </b-form-select>
                    </b-form-group>
                </div>
                <b-row>
                    <b-col lg="4" sm="6" cols="12">
                        <div class="custom-card-dashboard balance-card">
                            <div class="d-flex align-items-center">
                                <div class="card-icon">
                                    <i class="mb-2 fa fa-laptop"></i>
                                </div>
                                <div class="card-data ml-4">
                                    <p class="mb-0 text-muted">Gadai Elektronik</p>
                                    <strong class="mb-0">
                                        Rp. {{$helper.addThousandSeparator(showDataPembayaranTahunanAll.nominalElek)}}
                                    </strong>
                                    <p class="mb-0">{{$helper.addThousandSeparator(showDataPembayaranTahunanAll.jumlahElek)}} Unit</p>
                                </div>
                            </div>
                        </div>
                    </b-col>
                    <b-col lg="4" sm="6" cols="12">
                        <div class="custom-card-dashboard balance-card">
                            <div class="d-flex align-items-center">
                                <div class="card-icon">
                                    <i class="mb-2 fa fa-book"></i>
                                </div>
                                <div class="card-data ml-4">
                                    <p class="mb-0 text-muted">Gadai BPKB</p>
                                    <strong class="mb-0">
                                        Rp. {{$helper.addThousandSeparator(showDataPembayaranTahunanAll.nominalBpkb)}}
                                    </strong>
                                    <p class="mb-0">{{$helper.addThousandSeparator(showDataPembayaranTahunanAll.jumlahBpkb)}} Unit</p>
                                </div>
                            </div>
                        </div>
                    </b-col>
                    <b-col lg="4" sm="6" cols="12">
                        <div class="custom-card-dashboard balance-card">
                            <div class="d-flex align-items-center">
                                <div class="card-icon">
                                    <i class="mb-2 fa fa-car"></i>
                                </div>
                                <div class="card-data ml-4">
                                    <p class="mb-0 text-muted">Gadai Kendaraan</p>
                                    <strong class="mb-0">
                                        Rp. {{$helper.addThousandSeparator(showDataPembayaranTahunanAll.nominalKend)}}
                                    </strong>
                                    <p class="mb-0">{{$helper.addThousandSeparator(showDataPembayaranTahunanAll.jumlahKend)}}</p>
                                </div>
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <b-card >
                    <template v-slot:header>
                        <h5>Laporan {{ input.tipePembayaranTahunan == 1 ? "Perpanjangan" : "Pelunasan" }} Cabang Tahunan</h5>
                    </template>
                    <b-table bordered hover show-empty
                        :busy="isBusy"
                        :items="showDataPembayaranTahunan" 
                        :fields="fieldTahunan" 
                        responsive class="mb-3">
                        <template v-slot:table-busy>
                            <div class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong>  Loading data...</strong>
                            </div>
                        </template>
                        <template v-slot:empty>
                            Tidak ada data pembayaran.
                        </template>
                        <template v-slot:thead-top>
                            <b-tr>
                                <b-th># </b-th>
                                <b-th colspan="2">Elektronik</b-th>
                                <b-th colspan="2">BPKB</b-th>
                                <b-th colspan="2">Kendaraan</b-th>
                            </b-tr>
                        </template>
                        <template v-slot:cell(jumlahElek)="row">
                            <div class="text-right no-wrap">
                                {{ $helper.addThousandSeparator(row.item.jumlahElek) }}                 
                            </div>
                        </template>
                        <template v-slot:cell(jumlahKend)="row">
                            <div class="text-right no-wrap">
                                {{ $helper.addThousandSeparator(row.item.jumlahKend) }}                 
                            </div>
                        </template>
                        <template v-slot:cell(jumlahBpkb)="row">
                            <div class="text-right no-wrap">
                                {{ $helper.addThousandSeparator(row.item.jumlahBpkb) }}                 
                            </div>
                        </template>
                        <template v-slot:cell(nominalElek)="row">
                            <div class="text-right no-wrap" v-if="row.item.nominalElek == null">{{$helper.addThousandSeparator(row.item.nominalElek)}} </div>
                            <div class="text-right no-wrap" v-else-if="row.item.nominalElek < 0">- Rp{{$helper.addThousandSeparator(row.item.nominalElek).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.nominalElek)}} </div>
                        </template>
                        <template v-slot:cell(nominalKend)="row">
                            <div class="text-right no-wrap" v-if="row.item.nominalKend == null">{{$helper.addThousandSeparator(row.item.nominalKend)}} </div>
                            <div class="text-right no-wrap" v-else-if="row.item.nominalKend < 0">- Rp{{$helper.addThousandSeparator(row.item.nominalKend).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.nominalKend)}} </div>
                        </template>
                        <template v-slot:cell(nominalBpkb)="row">
                            <div class="text-right no-wrap" v-if="row.item.nominalBpkb == null">{{$helper.addThousandSeparator(row.item.nominalBpkb)}} </div>
                            <div class="text-right no-wrap" v-else-if="row.item.nominalBpkb < 0">- Rp{{$helper.addThousandSeparator(row.item.nominalBpkb).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.nominalBpkb)}} </div>
                        </template>
                    </b-table>
                </b-card>
            </div>
        </div>
        
        <b-modal id="modal-periode-search" title="Laporan Periode" no-close-on-backdrop no-close-on-esc
            :hide-header-close="isSubmitting" hide-footer>
            <div class="search-wrapper align-items-center justify-content-between">
                <b-form-group
                    label="Tanggal Gadai"
                    label-for="filterInput"
                    class="form-group-wrapper mb-3"
                >
                    <div class="d-flex search-input-wrapper">
                        <b-form-input class="mr-2"
                            v-model="input.filterFromDate" name="filterFromDate"
                            id="filterDate"
                            type="date"
                        ></b-form-input>
                        <span class="mr-2 d-flex align-items-center">s/d</span>
                        <b-form-input class="mr-2"
                            v-model="input.filterToDate" name="filterToDate"
                            type="date"
                        ></b-form-input>
                        <b-button class="mr-2" variant="pgiBtn" name="resetTableBtn" :disabled="isLoading" @click="onResetFilterTanggal">Reset</b-button>
                    </div>
                </b-form-group>

                <b-button variant="pgiBtn" class="mr-2 download-btn" :disabled="isLoading" @click="confirmPeriodeWeb()">
                    Lihat di Web
                </b-button>
                <b-button variant="pgiBtn" class="download-btn" :disabled="isLoading" @click="confirmPeriodeDownload()">
                    <i class="fa fa-download mr-2"></i>
                    Download Excel
                </b-button>
            </div>
        </b-modal>
        <b-modal id="modal-tahunan-search" title="Laporan Tahunan" no-close-on-backdrop no-close-on-esc
            :hide-header-close="isSubmitting" hide-footer>
            <div class="form-content-wrapper mb-0">
                <b-form-group label="Tahun">
                    <b-form-select v-model="input.tahun" name="tahun" :options="tahunOption" required>
                        <template v-slot:first>
                            <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
                        </template>
                    </b-form-select>
                </b-form-group>
            </div>
            <b-button variant="pgiBtn" class="mr-2 download-btn" :disabled="isLoading" @click="confirmTahunanWeb()">
                Lihat di Web
            </b-button>
            <b-button variant="pgiBtn" class="download-btn" :disabled="isLoading" @click="confirmTahunanDownload()">
                <i class="fa fa-download mr-2"></i>
                Download Excel
            </b-button>
        </b-modal>
        <b-modal id="modal-periode-webPassword" @shown="focusPeriodeWebPassword" title="Confirm Web Laporan PP/ PL" :no-close-on-backdrop="isSubmitting" :no-close-on-esc="isSubmitting"
            :hide-header-close="isSubmitting">
            <b-form id="webPasswordForm" @submit.prevent="openPeriodeWeb">
                <div class="form-content-wrapper mb-0">
                    <b-form-group label="Password" class="mb-0">
                        <b-form-input ref="passwordPeriodeWeb"
                        v-model="input.passwordPeriodeWeb"
                        name="passwordPeriodeWeb"
                        type="password"
                        required
                        ></b-form-input>
                    </b-form-group>
                </div>
            </b-form>
            <template v-slot:modal-footer="{ ok, cancel }">
                <b-button variant="secondary" name="cancelWebPasswordBtn" :disabled="isSubmitting" @click="cancel()">
                    Cancel
                </b-button>
                <b-button variant="pgiBtn" name="okeWebPasswordBtn" :disabled="isSubmitting" type="submit" form="webPasswordForm">
                    <b-spinner small type="grow" v-if="isSubmitting"></b-spinner>
                    {{isSubmitting ? 'Memproses...' : 'Submit'}}
                </b-button>
            </template>
        </b-modal>
        <b-modal id="modal-periode-downloadPassword" @shown="focusPeriodeDownloadPassword" title="Confirm Download Laporan PP/ PL" :no-close-on-backdrop="isSubmitting" :no-close-on-esc="isSubmitting"
            :hide-header-close="isSubmitting">
            <b-form id="downloadExcelPasswordForm" @submit.prevent="openPeriodeDownload">
                <div class="form-content-wrapper mb-0">
                    <b-form-group label="Password" class="mb-0">
                        <b-form-input ref="passwordPeriodeDownload"
                        v-model="input.passwordPeriodeDownload"
                        name="passwordPeriodeDownload"
                        type="password"
                        required
                        ></b-form-input>
                    </b-form-group>
                </div>
            </b-form>
            <template v-slot:modal-footer="{ ok, cancel }">
                <b-button variant="secondary" name="cancelDownloadPasswordBtn" :disabled="isSubmitting" @click="cancel()">
                    Cancel
                </b-button>
                <b-button variant="pgiBtn" name="okeDownloadPasswordBtn" :disabled="isSubmitting" type="submit" form="downloadExcelPasswordForm">
                    <b-spinner small type="grow" v-if="isSubmitting"></b-spinner>
                    {{isSubmitting ? 'Memproses...' : 'Submit'}}
                </b-button>
            </template>
        </b-modal>
        <b-modal id="modal-tahunan-webPassword" @shown="focusTahunanWebPassword" title="Confirm Web Laporan Tahunan PP/ PL" :no-close-on-backdrop="isSubmitting" :no-close-on-esc="isSubmitting"
            :hide-header-close="isSubmitting">
            <b-form id="webTahunanPasswordForm" @submit.prevent="openTahunanWeb">
                <div class="form-content-wrapper mb-0">
                    <b-form-group label="Password" class="mb-0">
                        <b-form-input ref="passwordTahunanWeb"
                        v-model="input.passwordTahunanWeb"
                        name="passwordTahunanWeb"
                        type="password"
                        required
                        ></b-form-input>
                    </b-form-group>
                </div>
            </b-form>
            <template v-slot:modal-footer="{ ok, cancel }">
                <b-button variant="secondary" name="cancelWebPasswordBtn" :disabled="isSubmitting" @click="cancel()">
                    Cancel
                </b-button>
                <b-button variant="pgiBtn" name="okeWebPasswordBtn" :disabled="isSubmitting" type="submit" form="webTahunanPasswordForm">
                    <b-spinner small type="grow" v-if="isSubmitting"></b-spinner>
                    {{isSubmitting ? 'Memproses...' : 'Submit'}}
                </b-button>
            </template>
        </b-modal>
        <b-modal id="modal-tahunan-downloadPassword" @shown="focusTahunanDownloadPassword" title="Confirm Download Laporan Tahunan PP/ PL" :no-close-on-backdrop="isSubmitting" :no-close-on-esc="isSubmitting"
            :hide-header-close="isSubmitting">
            <b-form id="downloadTahunanPasswordForm" @submit.prevent="openTahunanDownload">
                <div class="form-content-wrapper mb-0">
                    <b-form-group label="Password" class="mb-0">
                        <b-form-input ref="passwordTahunanDownload"
                        v-model="input.passwordTahunanDownload"
                        name="passwordTahunanDownload"
                        type="password"
                        required
                        ></b-form-input>
                    </b-form-group>
                </div>
            </b-form>
            <template v-slot:modal-footer="{ ok, cancel }">
                <b-button variant="secondary" name="cancelDownloadPasswordBtn" :disabled="isSubmitting" @click="cancel()">
                    Cancel
                </b-button>
                <b-button variant="pgiBtn" name="okeDownloadPasswordBtn" :disabled="isSubmitting" type="submit" form="downloadTahunanPasswordForm">
                    <b-spinner small type="grow" v-if="isSubmitting"></b-spinner>
                    {{isSubmitting ? 'Memproses...' : 'Submit'}}
                </b-button>
            </template>
        </b-modal>
        <b-modal id="modal-download-excel" centered title="Download Excel" hide-footer no-close-on-backdrop>
            <div class="text-center" v-if="isLoading == true">
                <b-spinner class="align-middle mb-4"></b-spinner>
                <p class="mb-0">Sedang memproses, mohon menunggu...</p>
            </div>
            <div class="show-btn-download" v-else>
                <p class="">
                    Silakan download dengan klik tombol dibawah ini :
                </p>
                <b-button variant="pgiBtn" class="mb-0 download-btn">
                    <a v-bind:href="$baseFilePath + filePathDownload" download>
                        <i class="fa fa-download mr-2"></i>
                        Download Excel
                    </a>
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>

export default {
    name: 'laporan-pp-pl',
    data(){
        return{
            isSubmitting: false,
            input:{
                filterFromDate: null,
                filterToDate: null,
                passwordPeriodeDownload: "",
                passwordPeriodeWeb: "",
                //show web
                
                show: 10,
                filterCabang: null,
                tipePembayaranPeriode: 1,

                //
                tahun: null,
                passwordTahunanWeb: "",
                passwordTahunanDownload: "",
                tipePembayaranTahunan: 1
            },

            //
            isLoading: false,
            filePathDownload: "",
            query: "",
            showWebPeriode: false,
            periodeStart: '',
            periodeEnd: '',
            isBusy: true,
            tipePembayaranOption: [
                {id: 1, name: 'Perpanjangan'},
                {id: 2, name: 'Pelunasan'}
            ],
            fields: [
                { key: "cabangName", label: "Cabang"},
                { key: "jumlahElek", label: "Jumlah", sortable: true },
                { key: "nominalElek", label: "Nominal", sortable: true },
                { key: "jumlahBpkb", label: "Jumlah", sortable: true },
                { key: "nominalBpkb", label: "Nominal", sortable: true },
                { key: "jumlahKend", label: "Jumlah", sortable: true },
                { key: "nominalKend", label: "Nominal", sortable: true },
            ],
            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],
            dataPembayaranAll : {},
            showDataPembayaranAll: [],
            showDataPembayaran: [],
            cabangOption: [],
            currentPage: 1,
            perPage: 10,
            rows: null,
            totalViewText: "",
            page: '',
            size: '',
            //
            periodeTahun: '',
            showWebTahunan: false,
            tahunOption: [],
            fieldTahunan: [
                { key: "cabangName", label: "Bulan"},
                { key: "jumlahElek", label: "Jumlah", sortable: true },
                { key: "nominalElek", label: "Nominal", sortable: true },
                { key: "jumlahBpkb", label: "Jumlah", sortable: true },
                { key: "nominalBpkb", label: "Nominal", sortable: true },
                { key: "jumlahKend", label: "Jumlah", sortable: true },
                { key: "nominalKend", label: "Nominal", sortable: true },
            ],
            showDataPembayaranTahunanAll: [],
            showDataPembayaranTahunan: [],
            dataPembayaranTahunanAll : {},
        }
    }, 
    watch: {
        "input.tipePembayaranPeriode": function(newValue) {
            if(newValue == 1){
                this.showDataPembayaranAll = this.dataPembayaranAll.pp
                this.showDataPembayaran = this.dataPembayaranAll.pp.entries
            }else{
                this.showDataPembayaranAll = this.dataPembayaranAll.pl
                this.showDataPembayaran = this.dataPembayaranAll.pl.entries
            }
            this.updateTotalItem()
            this.input.filterCabang = null
            this.perPage = 10
            this.currentPage = 1
        },
        "input.tipePembayaranTahunan": function(newValue) {
            if(newValue == 1){
                this.showDataPembayaranTahunanAll = this.dataPembayaranTahunanAll.pp
                this.showDataPembayaranTahunan = this.dataPembayaranTahunanAll.pp.entries
            }else{
                this.showDataPembayaranTahunanAll = this.dataPembayaranTahunanAll.pl
                this.showDataPembayaranTahunan = this.dataPembayaranTahunanAll.pl.entries
            }
        },
    }, 
    methods: {
		init(){
			var thisYear = new Date().getFullYear()
			for(var i = 2016; i <= thisYear; i++) {
				this.tahunOption.push(i)
			}
		},
        focusPeriodeWebPassword(){
            this.$refs.passwordPeriodeWeb.focus()
        },
        focusPeriodeDownloadPassword(){
            this.$refs.passwordPeriodeDownload.focus()
        },
        focusTahunanWebPassword(){
            this.$refs.passwordTahunanWeb.focus()
        },
        focusTahunanDownloadPassword(){
            this.$refs.passwordTahunanDownload.focus()
        },
        openLaporanPeriode(){
            this.$bvModal.show('modal-periode-search')
        },

        openLaporanTahunan(){
            this.$bvModal.show('modal-tahunan-search')
        },

        onResetFilterTanggal(){
            this.input.filterFromDate = null
            this.input.filterToDate = null
            this.showWebPeriode = false
        },

        confirmTahunanDownload(){
            if(!this.$helper.isNotNullAndNotEmpty(this.input.tahun)){
                this.$helper.toastErr(this, "Mohon isi tahun laporan!")
            }else{
                if(localStorage.getItem('isauthorized') == 'true'){
                    this.openTahunanDownload()
                    this.input.passwordTahunanDownload = localStorage.getItem('lapeksPassword')
                }else{
                    this.$bvModal.show('modal-tahunan-downloadPassword')
                }
            }
        },

        openTahunanDownload(){
            this.showWebTahunan = false
            this.showWebPeriode = false
            this.isLoading = true
            this.$bvModal.hide('modal-tahunan-search')
            this.$bvModal.show('modal-download-excel')
            this.$bvModal.hide('modal-tahunan-downloadPassword')
            setTimeout(() => { this.axiosTahunanDownload() }, 500)
        },

        axiosTahunanDownload(){
            this.$axios.get(`laporan-eksekutif/pp-pl-tahunan/dl/?tahun=${this.input.tahun}&password=${this.input.passwordTahunanDownload}`).then(response => {
                this.filePathDownload = response.data
                if(localStorage.getItem('isauthorized') == 'false'){
                    localStorage.setItem('lapeksPassword', this.input.passwordTahunanDownload)
                    localStorage.setItem('isauthorized', 'true')
                }
                this.input.passwordTahunanDownload = ""
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.input.passwordTahunanDownload = ""
                this.$bvModal.hide('modal-download-excel')
                this.$helper.toastErr(this, error.response.data.reason)
            })
            .finally(() => {
                this.isLoading = false
            })
        },

        confirmPeriodeDownload(){
            this.showWebTahunan = false
            this.showWebPeriode = false
            if(!this.$helper.isNotNullAndNotEmpty(this.input.filterFromDate)){
                this.$helper.toastErr(this, "Mohon isi tanggal mulai filter!")
            }else if((this.$helper.isNotNullAndNotEmpty(this.input.filterToDate) && this.$helper.isNotNullAndNotEmpty(this.input.filterFromDate)) && (Date.parse(this.input.filterToDate) < Date.parse(this.input.filterFromDate))){
                this.$helper.toastErr(this, "Tanggal akhir lebih kecil daripada tanggal mulai!")
            }else{
                if(localStorage.getItem('isauthorized') == 'true'){
                    this.openPeriodeDownload()
                    this.input.passwordPeriodeDownload = localStorage.getItem('lapeksPassword')
                }else{
                    this.$bvModal.show('modal-periode-downloadPassword')
                }
            }
        },

        openPeriodeDownload(){
            this.isLoading = true
            this.$bvModal.hide('modal-periode-search')
            this.$bvModal.show('modal-download-excel')
            this.$bvModal.hide('modal-periode-downloadPassword')
            setTimeout(() => { this.axiosPeriodeDownload() }, 500)
        },

        axiosPeriodeDownload(){
            if(!this.$helper.isNotNullAndNotEmpty(this.input.filterToDate)){
                this.query = `startDate=${this.input.filterFromDate}&password=${this.input.passwordPeriodeDownload}`
            }else{
                this.query = `startDate=${this.input.filterFromDate}&endDate=${this.input.filterToDate}&password=${this.input.passwordPeriodeDownload}`
            }
            this.$axios.get(`laporan-eksekutif/pp-pl/dl/?${this.query}`).then(response => {
                this.filePathDownload = response.data
                if(localStorage.getItem('isauthorized') == 'false'){
                    localStorage.setItem('lapeksPassword', this.input.passwordPeriodeDownload)
                    localStorage.setItem('isauthorized', 'true')
                }
                this.input.passwordPeriodeDownload = ""
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.input.passwordPeriodeDownload = ""
                this.$bvModal.hide('modal-download-excel')
                this.$helper.toastErr(this, error.response.data.reason)
            })
            .finally(() => {
                this.isLoading = false
            })
        },

        confirmTahunanWeb(){
            if(!this.$helper.isNotNullAndNotEmpty(this.input.tahun)){
                this.$helper.toastErr(this, "Mohon isi tahun laporan!")
            }else{
                if(localStorage.getItem('isauthorized') == 'true'){
                    this.openTahunanWeb()
                    this.input.passwordTahunanWeb = localStorage.getItem('lapeksPassword')
                }else{
                    this.$bvModal.show('modal-tahunan-webPassword')
                }
            }
        },

        openTahunanWeb(){
            this.showWebTahunan = true
            this.showWebPeriode = false
            this.isLoading = true
            this.$bvModal.hide('modal-tahunan-search')
            this.$bvModal.hide('modal-tahunan-webPassword')
            setTimeout(() => { this.axiosTahunanWeb() }, 500)
        },

        axiosTahunanWeb(){
            this.$axios.get(`laporan-eksekutif/pp-pl-tahunan/?tahun=${this.input.tahun}&password=${this.input.passwordTahunanWeb}`).then(response => {
                this.dataPembayaranTahunanAll = response.data
                this.showDataPembayaranTahunanAll = response.data.pp
                this.showDataPembayaranTahunan = response.data.pp.entries
                this.input.tipePembayaranTahunan = 1
                this.isLoading = false
                this.isBusy = false
               
                this.periodeTahun = this.input.tahun
                if(localStorage.getItem('isauthorized') == 'false'){
                    localStorage.setItem('lapeksPassword', this.input.passwordTahunanWeb)
                    localStorage.setItem('isauthorized', 'true')
                }
                this.input.passwordTahunanWeb = ""
            })
            .catch(error => {
                console.log(error)
                this.$helper.toastErr(this, error.response.data.reason)
                this.input.passwordTahunanWeb = ""
                this.showWebTahunan = false
                this.isLoading = false
            })
            .finally(() => {
                this.isLoading = false
            })
        },

        confirmPeriodeWeb(){
            if(!this.$helper.isNotNullAndNotEmpty(this.input.filterFromDate)){
                this.$helper.toastErr(this, "Mohon isi tanggal mulai filter!")
            }else if((this.$helper.isNotNullAndNotEmpty(this.input.filterToDate) && this.$helper.isNotNullAndNotEmpty(this.input.filterFromDate)) && (Date.parse(this.input.filterToDate) < Date.parse(this.input.filterFromDate))){
                this.$helper.toastErr(this, "Tanggal akhir lebih kecil daripada tanggal mulai!")
            }else{
                if(localStorage.getItem('isauthorized') == 'true'){
                    this.openPeriodeWeb()
                    this.input.passwordPeriodeWeb = localStorage.getItem('lapeksPassword')
                }else{
                    this.$bvModal.show('modal-periode-webPassword')
                }
            }
        },

        openPeriodeWeb(){
            this.showWebPeriode = true
            this.showWebTahunan = false
            this.isLoading = true
            this.$bvModal.hide('modal-periode-search')
            this.$bvModal.hide('modal-periode-webPassword')
            setTimeout(() => { this.axiosPeriodeWeb() }, 500)
        },

        axiosPeriodeWeb(){
            if(!this.$helper.isNotNullAndNotEmpty(this.input.filterToDate)){
                this.query = `startDate=${this.input.filterFromDate}&password=${this.input.passwordPeriodeWeb}`
            }else{
                this.query = `startDate=${this.input.filterFromDate}&endDate=${this.input.filterToDate}&password=${this.input.passwordPeriodeWeb}`
            }

            let getCabang = this.getOptionCabang()

            let getDataPembayaran = this.$axios.get(`laporan-eksekutif/pp-pl/?${this.query}`).then(response => {
                this.dataPembayaranAll = response.data
                this.showDataPembayaranAll = response.data.pp
                this.showDataPembayaran = response.data.pp.entries
                this.input.tipePembayaranPeriode = 1
                this.updateTotalItem()
    
            })

            Promise.all([getCabang, getDataPembayaran]).then(() => {
                this.input.filterCabang = null
                this.isLoading = false
                this.isBusy = false
                if(localStorage.getItem('isauthorized') == 'false'){
                    localStorage.setItem('lapeksPassword', this.input.passwordPeriodeWeb)
                    localStorage.setItem('isauthorized', 'true')
                }
                this.input.passwordPeriodeWeb = ""
                this.periodeStart = this.input.filterFromDate
                if(this.$helper.isNotNullAndNotEmpty(this.input.filterToDate)){
                    this.periodeEnd = this.input.filterToDate
                }else{
                    this.periodeEnd = ""
                }
            })
            .catch(error => {
                console.log(error)
                this.$helper.toastErr(this, error.response.data.reason)
                this.input.passwordPeriodeWeb = ""
                this.showWebPeriode = false
                this.isLoading = false
            })
        },

        getOptionCabang(){
            if(this.cabangOption.length == 0){
                this.$axios.get("cabang/all-selection").then(response => {
              
                    response.data.forEach((element) => {
                        if(element.id != this.srcCabangId)
                            this.cabangOption.push(element)
                    })
                })
            }
        },

        //----------------- Fungsi Ambil Data Daftar Gadai -----------------

        getDataPembayaran(){
            this.showDataPembayaran = this.showDataPembayaranAll.entries
            this.toggleBusy()
            this.updateTotalItem()
        },

        //----------------- Fungsi Pagination, Sorting, dan loading -----------------

        onLimitChange(){
            this.perPage = this.input.show
            this.onPageChange()
        },

        onPageChange(){
            let prevLimit = null
            let limit = null
            prevLimit = (this.currentPage-1) * this.input.show + 1
            limit = (this.currentPage-1) * this.input.show + this.input.show
            if(limit > this.rows) limit = this.rows
            this.totalViewText = "Menampilkan "+ prevLimit + " - " + limit + " dari " + this.rows + " entri"
        },

        onReset(){
            this.input.filterCabang = null
            this.toggleBusy()
            this.getDataPembayaran()
        },
        
        onFilter(){
            
            if(this.input.filterCabang == null){
                this.$helper.toastErr(this, "Silakan isi nama cabang terlebih dahulu!")
            }else{
                let filteredArray = []

                for (var x of this.showDataPembayaranAll.entries) {
                    if(x.cabangId == this.input.filterCabang.id){
                        filteredArray.push(x)
                    }
                }
                
                this.showDataPembayaran = filteredArray
                this.onFiltered(this.showDataPembayaran)
            }
        },

        onFiltered(filteredItems) {
            this.rows = filteredItems.length
            this.currentPage = 1
            this.perPage = this.input.show
            let prevLimit = null
            let limit = null
            
            prevLimit = (this.currentPage-1) * this.rows + 1
            limit = (this.currentPage-1) * this.rows + this.rows
            if (limit > this.input.show) limit = this.input.show
            this.totalViewText = "Menampilkan "+ prevLimit + " - " + limit + " dari " + this.rows + " entri"
        },

        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

        toggleBusy() {
            if(this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },

        updateTotalItem(){
            this.rows = this.showDataPembayaran.length
            if (this.perPage > this.rows) this.perPage = this.rows
            this.totalViewText = "Menampilkan 1 - " + this.perPage + " dari " + this.rows + " entri"
        },
	},
	created(){
        this.init()
    }
}
</script>
